/** Measure html5-qrcode's real scan hole inside the stage (works on iPhone). */
export function measureScanHole(stage: HTMLElement): {
  top: number;
  left: number;
  width: number;
  height: number;
} | null {
  const region = stage.querySelector('#qr-shaded-region') as HTMLElement | null;
  if (!region) {
    return null;
  }

  const stageRect = stage.getBoundingClientRect();
  const regionRect = region.getBoundingClientRect();
  const style = window.getComputedStyle(region);
  const borderTop = parseFloat(style.borderTopWidth) || 0;
  const borderRight = parseFloat(style.borderRightWidth) || 0;
  const borderBottom = parseFloat(style.borderBottomWidth) || 0;
  const borderLeft = parseFloat(style.borderLeftWidth) || 0;

  const width = regionRect.width - borderLeft - borderRight;
  const height = regionRect.height - borderTop - borderBottom;
  if (width < 48 || height < 48) {
    return null;
  }

  return {
    top: regionRect.top - stageRect.top + borderTop,
    left: regionRect.left - stageRect.left + borderLeft,
    width,
    height,
  };
}

export function computeQrBoxSize(viewfinderWidth: number, viewfinderHeight: number): number {
  const limit = Math.min(viewfinderWidth, viewfinderHeight);
  if (!Number.isFinite(limit) || limit <= 0) {
    return 0;
  }
  return Math.max(1, Math.floor(limit * 0.72));
}
